"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan
 */
var core_1 = require("@angular/core");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var SisSingleSelectEntitySearchSettingsComponent = /** @class */ (function (_super) {
    __extends(SisSingleSelectEntitySearchSettingsComponent, _super);
    function SisSingleSelectEntitySearchSettingsComponent(communicationService) {
        return _super.call(this, communicationService) || this;
    }
    SisSingleSelectEntitySearchSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-singleselect-entity-search-settings',
            template: "\n               <sis-ng-tooltip-settings [(settings)]=\"tooltipSettings\" [languages]=\"languages\"\n                                        [currentLanguageId]=\"currentLanguageId\">\n               </sis-ng-tooltip-settings>\n               <sis-ng-control-label-settings [languages]=\"languages\" [currentLanguageId]=\"currentLanguageId\"\n                                              [(titleModel)]=\"controlLabel\">\n               </sis-ng-control-label-settings>"
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-singleselect-entity-search-settings\n                                [state]=\"%{state}\" [languages]=\"%{languages}\"\n                                [currentLanguageId]=\"%{currentLanguageId}\"\n                                [controlLabel]=\"%{controlLabel}\">\n                </sis-singleselect-entity-search-settings>"
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService])
    ], SisSingleSelectEntitySearchSettingsComponent);
    return SisSingleSelectEntitySearchSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.SisSingleSelectEntitySearchSettingsComponent = SisSingleSelectEntitySearchSettingsComponent;
//# sourceMappingURL=sis-single-select-entity-search-settings.component.js.map